import { z } from "zod";
// The rollout admin surface (Relationships-Australia-WA/Services-Delivery-Technology-Upgrade#202), resolved to human names against the local
// ICIS mirror. Two reads: the locations an administrator can configure, and —
// for one of them — every program with the state of each feedback channel.
//
// Names are non-nullable here, unlike the tree this replaced: both lists are
// built FROM the mirror rather than from a set of separately-configured ids, so
// every id shown has a name by construction and there is no unresolved case to
// fall back from.
// How much of a location's rollout is switched on, summarised for the location
// list so an administrator can see where feedback is live without opening every
// site in turn. "all" means every program listed for that location has BOTH
// channels on; "partial" means at least one channel is on somewhere; "none"
// covers a location with nothing on, including one with no programs to list.
export const RolloutCoverageSchema = z.enum(["none", "partial", "all"]);
export const RolloutLocationSchema = z.object({
    id: z.guid(),
    name: z.string(),
    coverage: RolloutCoverageSchema,
});
export const RolloutLocationsResponseSchema = z.object({
    locations: z.array(RolloutLocationSchema),
});
// One program's feedback channels at the location being configured. All three are
// independent: a program can capture feedback on the kiosk on site while no
// client is ever contacted — which is what lets programs with at-risk clients be
// rolled out at all — and the challenge suits programs that display a printed
// code rather than appear on a tablet.
export const ProgramChannelsSchema = z.object({
    id: z.guid(),
    name: z.string(),
    notificationsEnabled: z.boolean(),
    kioskEnabled: z.boolean(),
    challengeEnabled: z.boolean(),
});
export const LocationRolloutResponseSchema = z.object({
    programs: z.array(ProgramChannelsSchema),
});
// The desired state of every channel at one location. Sent whole rather than as
// a diff, so the server never reconciles partial updates or has to guess what an
// absent program means.
export const SaveProgramChannelsSchema = z.object({
    id: z.guid(),
    notificationsEnabled: z.boolean(),
    kioskEnabled: z.boolean(),
    challengeEnabled: z.boolean(),
});
export const SaveLocationRolloutSchema = z.object({
    programs: z.array(SaveProgramChannelsSchema),
});
